import React from 'react';
import { Result, Button } from 'antd';
import { logError } from '../utils/errorHandler';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            hasError: false, 
            error: null, 
            errorInfo: null 
        };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log the error
        this.setState({
            error: error,
            errorInfo: errorInfo
        });

        // Log error for monitoring
        logError(error, 'React Error Boundary');
        
        // You can also log the error to an error reporting service here
        // Example: Sentry.captureException(error, { extra: errorInfo });
    }

    handleReload = () => {
        window.location.reload();
    };

    handleGoHome = () => {
        window.location.href = '/';
    };

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div style={{ 
                    padding: '50px 20px', 
                    textAlign: 'center',
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Result
                        status="error"
                        title="Something went wrong"
                        subTitle="We're sorry, but something unexpected happened. Our team has been notified."
                        extra={[
                            <Button 
                                type="primary" 
                                key="reload" 
                                onClick={this.handleReload}
                                style={{ marginRight: 8 }}
                            >
                                Reload Page
                            </Button>,
                            <Button 
                                key="home" 
                                onClick={this.handleGoHome}
                            >
                                Go to Home
                            </Button>
                        ]}
                    />
                    
                    {/* Show error details in development */}
                    {process.env.NODE_ENV === 'development' && this.state.error && (
                        <div style={{ 
                            marginTop: 20, 
                            textAlign: 'left',
                            maxWidth: '800px',
                            margin: '20px auto',
                            padding: '20px',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '8px',
                            fontSize: '12px'
                        }}>
                            <h4>Error Details (Development Only):</h4>
                            <pre style={{ 
                                whiteSpace: 'pre-wrap', 
                                wordBreak: 'break-word',
                                backgroundColor: '#fff',
                                padding: '10px',
                                borderRadius: '4px',
                                border: '1px solid #d9d9d9'
                            }}>
                                {this.state.error && this.state.error.toString()}
                                <br />
                                {this.state.errorInfo.componentStack}
                            </pre>
                        </div>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary; 